var _circle, _g, _circle2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMacedonia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ffda44",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m294.932 509.057c41.636-6.352 79.962-22.748 112.456-46.618l-151.388-206.439z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.067 2.943c-41.635 6.352-79.961 22.748-112.457 46.617l151.39 206.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.61 462.439c32.494 23.869 70.82 40.265 112.455 46.619l38.935-253.058z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.56 104.61c-23.87 32.496-40.264 70.821-46.617 112.457l253.057 38.933z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.943 294.932c6.352 41.636 22.748 79.962 46.618 112.456l206.439-151.388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.057 217.067c-6.353-41.635-22.748-79.961-46.618-112.456l-206.439 151.389z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.388 49.559c-32.495-23.869-70.82-40.264-112.456-46.616l-38.932 253.057z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.441 407.389c23.869-32.495 40.264-70.822 46.618-112.456l-253.059-38.933z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 89.043
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ffda44",
    r: 66.783
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacedonia);
export default __webpack_public_path__ + "static/media/macedonia.dc5b33cb96fc1a0683b65d401d7c6b23.svg";
export { ForwardRef as ReactComponent };